import  React, { memo, VFC, useEffect, useState, Fragment, useCallback } from 'react';

import {
  Center,Spinner,
  Heading,Box,Flex,Spacer,Divider,
  Table,Tbody,Tr,Th,Td,
  Text,Button,Select
} from '@chakra-ui/react';
import { RepeatIcon } from '@chakra-ui/icons';
import { useLoginUser } from "../../../hooks/providers/useLoginUserProvider";
import { noticeAccountObj, rowDataObj, translateNoticeParam, noticeDetailObj } from '../../../types/issue';
import { useIssue } from '../../../hooks/useIssue';
import { useOpelog } from '../../../hooks/useOpelog';
import { CopyButton } from "../../atoms/button/CopyButton";

type Props = {
  noticeId: string;
  noticeDetailObj: noticeDetailObj|null;
  mailFileKey: string;
  setMailFileKey: (key:string)=>void;
  changeView: (key:string)=>void;
  executing: boolean;
};

export const NoticeDetailBase: VFC<Props> = memo((props) => {
  const { noticeId, noticeDetailObj, mailFileKey, setMailFileKey, changeView, executing } = props;
  const { loginUser } = useLoginUser();
  const [ mailList, setMailList ] = useState<Array<noticeAccountObj>>([]);
  const [ rowData, setRowData ] = useState<rowDataObj|null>(null);
  const host = window.location.host;
  
  useEffect(() => {
    if ( noticeDetailObj ) {
      setMailList(noticeDetailObj.mail_list);
      setMailFileKey(noticeDetailObj.mail_file_key);
    }
  }, [noticeDetailObj]);
  
  useEffect(() => {
    if ( mailList && noticeDetailObj ) {
      if ( mailFileKey ){
        loginUser.envType === 'DEV' && console.log('mailList', mailList);
        loginUser.envType === 'DEV' && console.log('mailFileKey', mailFileKey);
        loginUser.envType === 'DEV' && console.log('noticeDetailObj', noticeDetailObj);
        mailList
          .filter((item:noticeAccountObj) => (mailFileKey === item.file_key))
          .map((item:noticeAccountObj) =>{
            return(
              setRowData(
                {
                  'effected_account': item.account_list.join('<br>'),
                  'from_address': noticeDetailObj.from_address,
                  'to_address': noticeDetailObj.to_address,
                  'subject': noticeDetailObj.subject,
                  'class_name': noticeDetailObj.class_name,
                  'cloud_type': noticeDetailObj.cloud_type,
                  'body_origin': noticeDetailObj.body_origin,
                  'body_trans': noticeDetailObj.body_trans,
                  'body_trans_flag': noticeDetailObj.body_trans_flag,
                  'attachment_flag': noticeDetailObj.attachment_flag,
                }
              )
            );
          });
      }else {
        setRowData(null);
      }
    }
  }, [mailList, noticeDetailObj, mailFileKey, loginUser.envType]);

  
  return (
    <Center>
      <Box
        w="95%"
        bg="white"
        borderRadius="10px"
        shadow="md"
        margin="10px"
      >
        <Flex m="10px">
          <Heading size="md" margin="5px">
            <Flex>■通知メール詳細画面</Flex>
          </Heading> 
        </Flex>
        
        {executing ? (
          <Center h="80vh">
            <Spinner color="teal.500" />
          </Center>
          
        ) : (
          <>
          <Flex alignItems="center" marginLeft="10px" marginRight="10px">
            <Text fontSize="sm" paddingRight="8px">{`通知日時`}</Text>
            <Select w="300px" id="file_list" size="xs"
              onChange={(e) => changeView(e.target.value)} value={mailFileKey}>
              {mailList.map((item: noticeAccountObj,index:number) => (
                <option key={item.file_key+index} value={item.file_key}>{item.send_date}</option>
              ))}
            </Select>
            <Spacer />
            <CopyButton
              id="copy"
              isLoading={executing}
              value={`https://${host}/login.html?noticeId=${noticeId}`}>
              URLをコピー
            </CopyButton>
          </Flex>
          <Divider orientation="horizontal" mt="10px" />
          {rowData && (
            <NoticeDetailBaseSub
              noticeId={noticeId}
              row_data={rowData}
              file_key={mailFileKey}
            />
          )}
          </>
        )}
      </Box>
    </Center>
  );
});

type PropsSub = {
  noticeId: string;
  file_key: string;
  row_data: rowDataObj;
};

export const NoticeDetailBaseSub: VFC<PropsSub> = memo((props) => {
  const { noticeId, file_key, row_data } = props;
  const { loginUser } = useLoginUser();
  const { OutputOpelog } = useOpelog();
  const [ groupId ] = useState<string>(noticeId ?? '');
  const [ fileKey ] = useState<string>(file_key ?? '');
  const { translateNotice, noticeDetailObj, executing } = useIssue();
  const [ translateBody, setTranslateBody ] = useState<string|null>(null);
  const [ translateFlag, setTranslateFlag ] = useState(0);

  // 初期実行結果設定()
  useEffect(() => {
    if( row_data && noticeDetailObj === null ) {
      // loginUser.envType === 'DEV' && console.log('row_data', row_data);
      setTranslateBody(row_data.body_trans);
      setTranslateFlag(row_data.body_trans_flag);
    }
  }, [row_data,loginUser.envType,translateBody]);
  
  // 翻訳の実行
  const execTranslate = useCallback(() => {
    const params: translateNoticeParam = {
      'mail_group_id': groupId,
      'mail_file_key': fileKey
    }
    translateNotice(params);
    
    // ログ出力
    OutputOpelog('notice_mail_detail','translate',"MAIL_GROUP_ID#" + noticeId);
  
  }, [fileKey,groupId,translateNotice]);

  // 翻訳結果の反映
  useEffect(() => {
    if (noticeDetailObj) {
      loginUser.envType === 'DEV' && console.log('翻訳結果', noticeDetailObj);
      setTranslateBody(noticeDetailObj.body_trans);
      setTranslateFlag(noticeDetailObj.body_trans_flag);
    }
  }, [noticeDetailObj]);

  const displayTranlateButton = (trans_body:string|null,translateFlag:number) => {
    if( trans_body === null ) return( '' );
    if (translateFlag === 0) {
      return (
        <Button
          ml='30px'
          id="mail-button-trans"
          rightIcon={<RepeatIcon />}
          onClick={execTranslate}
          autoFocus={true}
          isLoading={executing}
        >
          翻訳
        </Button>
      );
    }
    
    // let body_data = trans_body;
    // if (!body_data){
    //   body_data = translateBody;
    // }
    const texts = trans_body.split(/(\n)/).map((item, index) => {
      return (
        <React.Fragment key={index}>
          { item.match(/\n/) ? <br /> : item }
        </React.Fragment>
      );
    });
    return (
      <Text style={{wordBreak: 'break-all'}}>{texts}</Text>
    );
  };

  const LineReplace = ({msg}: {msg:string}) => {
    if (!msg){
      return <Flex style={{wordBreak: 'break-all'}}></Flex>
    }
    const texts = msg.split(/(\n)/).map((item, index) => {
      return (
        <React.Fragment key={index}>
          { item.match(/\n/) ? <br /> : item }
        </React.Fragment>
      );
    });
    return (
      <Flex style={{wordBreak: 'break-all'}}>{texts}</Flex>
    )
  };

  return (
    <>
      {row_data === null ? (
        <Center>
          <Spinner color="teal.500" />
        </Center>
      
      ) : (
        <Box id="mailDetail" padding="10px">
          <Table id="table-mail-detail" border="1" colorScheme="gray" variant="striped" size="xs">
            <Tbody>
              <Tr>
                <Th backgroundColor="#aaaaaa" color="white" fontSize="md" w="20%">
                  影響アカウント
                </Th>
                <Td>{row_data.effected_account}</Td>
              </Tr>
              <Tr>
                <Th backgroundColor="#aaaaaa" color="white" fontSize="md">
                  クラウド種別
                </Th>
                <Td>{row_data.cloud_type}</Td>
              </Tr>
              <Tr>
                <Th backgroundColor="#aaaaaa" color="white" fontSize="md">
                  分類
                </Th>
                <Td>{row_data.class_name}</Td>
              </Tr>
              <Tr>
                <Th backgroundColor="#aaaaaa" color="white" fontSize="md">
                  送信元
                </Th>
                <Td>{row_data.from_address}</Td>
              </Tr>
              <Tr>
                <Th backgroundColor="#aaaaaa" color="white" fontSize="md">
                  宛先
                </Th>
                <Td>{row_data.to_address}</Td>
              </Tr>
              <Tr>
                <Th backgroundColor="#aaaaaa" color="white" fontSize="md">
                  タイトル
                </Th>
                <Td>{row_data.subject}</Td>
              </Tr>
              <Tr>
                <Th backgroundColor="#aaaaaa" color="white" fontSize="md">
                  本文(翻訳)
                </Th>
                <Td>{displayTranlateButton(translateBody,translateFlag)}</Td>
              </Tr>
              <Tr>
                <Th backgroundColor="#aaaaaa" color="white" fontSize="md">
                  本文
                </Th>
                <Td>
                  <LineReplace msg={row_data.body_origin} />
                </Td>
              </Tr>
              <Tr>
                <Th backgroundColor="#aaaaaa" color="white" fontSize="md">
                  添付ファイル有無
                </Th>
                <Td>{row_data.attachment_flag}</Td>
              </Tr>
            </Tbody>
          </Table>
        </Box>
      )}
    </>
  );
});
